var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 14,
    viewBox: "0 0 39 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5469 3.95898H0V13.6568H2.5469V3.95898Z",
    fill: "#F04F23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54122 13.6584H4.94531V4.18497C9.25546 3.25788 13.4581 3.62949 13.4962 7.18515L13.5656 13.6584H10.9207V7.72911C10.9207 7.14689 10.593 6.64932 10.058 6.41949C9.34001 6.11105 8.41668 6.28628 7.54113 6.3027V13.6584H7.54122Z",
    fill: "#F04F23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1909 10.5509C15.1667 7.48293 15.2825 4.41497 15.2111 1.34691L17.7906 0V4.00807H21.056V6.48972H17.7989C17.9248 9.97139 16.9107 12.7441 21.056 10.8654L22.2316 13.0694C21.1582 13.6816 19.969 13.932 18.7213 14C18.1268 14.0013 17.5713 13.8635 17.0531 13.5935C15.8877 12.9865 15.2013 11.8649 15.1909 10.5509Z",
    fill: "#F04F23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2755 3.93844C22.5033 2.12374 20.9037 8.34694 22.5943 11.6724C23.6486 13.7464 26.3451 14.49 30.9034 13.3468L30.128 11.0539C28.0218 11.4446 26.3951 11.742 25.3404 10.7885C24.6302 10.1645 24.6422 9.26163 24.6996 8.04155C24.7943 6.24808 27.2597 5.51387 28.2602 6.9491C28.2945 6.99837 28.3015 7.0555 28.2857 7.11341C28.2699 7.17142 28.2339 7.21518 28.1801 7.242L25.4995 8.58035L26.626 10.8007L31.0994 8.58035C31.0985 6.06988 30.1324 4.67763 28.2755 3.93844Z",
    fill: "#F04F23"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3711 13.7525V4.29948C34.2311 3.71386 36.2606 3.63681 38.4363 3.99741L37.6607 6.43005C36.8525 6.28495 36.0324 6.07146 34.9628 6.2749L34.9587 13.7525H32.3711Z",
    fill: "#F04F23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInter);
export default __webpack_public_path__ + "static/media/inter.bd5fc02a92da5281892ee841efe8fc28.svg";
export { ForwardRef as ReactComponent };